





















import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { NAME } from './constants';
import { store } from './store/list';
import { PARTNER_TYPE } from './store/types';

export default listFactory(NAME, store).extend({
	name: 'PartnerSelect',
	methods: {
		onCreateFyzickaOsobaClick() {
			openEdit(NAME, PageMode.CREATE, {
				props: true,
				filter: {
					...this.filter,
					PlatnySouhlas: true,
					PartnertypPzn: PARTNER_TYPE.FYZICKA,
				},
			});
		},
		onCreateInstituceClick() {
			openEdit(NAME, PageMode.CREATE, {
				props: true,
				filter: {
					...this.filter,
					PlatnySouhlas: true,
					PartnertypPzn: PARTNER_TYPE.PRAVNICKA,
				},
			});
		},
	},
});
